import { Injectable } from '@angular/core';
import {Flight} from '../../../dashboard/interfaces/Flight';

@Injectable()
export class FlightCacheService {
  flight: Flight;

  setFlight(flight: Flight) {
    this.flight = flight;
  }

  getFlight() {
    return this.flight;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/services/flight-cache/flight-cache.service.ts